export default "__VITE_ASSET__Bir83wsj__"